import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import InputMessageStyled from './styles/InputMessageStyled';

const Message = ({ message, color }) => (
  <InputMessageStyled>
    <Text font="din_bold" color={color}>
      {message}
    </Text>
  </InputMessageStyled>
);

Message.propTypes = {
  message: PropTypes.string,
  color: PropTypes.string,
};

Message.defaultProps = {
  message: '',
  color: 'red',
};

export default memo(Message);
